import React from 'react';
import { styledComponent } from '@dewise-devex/backstage-plugin-mui-uikit-react';
import { SvgIcon } from '@dewise-devex/backstage-plugin-mui-uikit-react';

export const UnassignedIconContainer = styledComponent('span')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  '& svg': {
    fill: theme.palette.surface.onSurfaceVar,
    height: '30px',
    width: '30px',
  },
}));

export const unassignedMember = {
  id: 'Unassigned',
  isUser: false,
  name: 'Unassigned',
  img: () => (
    <UnassignedIconContainer>
      <SvgIcon.unassigned />
    </UnassignedIconContainer>
  ),
};
